export default "<app-main *ngIf=\"languages\"\r\n    [languages]=\"languages\">\r\n</app-main>";